export function useVersionInfo() {
    return {
        currentVersion: __APP_VERSION__
    };
}